import { Phone, ArrowUpRight } from 'lucide-react';
import './PhoneLink.css';

export const PhoneLink = ({ phone, className = '', testId }) => {
  if (!phone) return null;
  const readable = phone.replace(/^(\+385)(\d{2})(\d{3})(\d{4})$/, '$1 $2 $3 $4');
  return <a href={`tel:${phone}`} className={`phone-link ${className}`} data-testid={testId} aria-label={`Nazovite ${readable}`}>
    <Phone size={15} strokeWidth={1.5} aria-hidden="true" />
    <span>{readable}</span>
    <ArrowUpRight size={15} aria-hidden="true" />
  </a>;
};